module.exports = __webpack_public_path__ + "static/img/brasao-cor-branco-vertical.68b0698.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/brasao-cor-branco-vertical.svg
// module id = wOM0
// module chunks = 15